import { Injectable } from '@angular/core';
import {
	Data$,
	RemoteData,
	appEntities,
	switchTap,
} from '@lycoris-nubila/ngx-lycoris';
import { TranslateService } from '@ngx-translate/core';
import { from, of } from 'rxjs';
import { catchError, map, startWith, switchMap } from 'rxjs/operators';

import { CvTemplateApplicationPort } from 'application/template/cv/port/cv-template-application.port';
import { CvTemplateConverterPort } from 'application/template/cv/port/cv-template-converter.port';
import { CvTemplateRepositoryPort } from 'application/template/cv/port/cv-template-repository.port';
import { CvTemplateOutput } from 'document/model/cv-template.output';
import { DocumentApiPort } from 'document/port/document-api.port';
import { ICvTemplate } from 'domain/template/cv/cv-template';
import { UserApplicationPort } from 'user/port/user-application.port';

@Injectable()
export class CvTemplateApplicationAdapter implements CvTemplateApplicationPort {
	constructor(
		private _documentApiPort: DocumentApiPort,
		private _translateService: TranslateService,
		private _cvTemplateRepositoryPort: CvTemplateRepositoryPort,
		private _cvTemplateConverterPort: CvTemplateConverterPort,
		private _userApplicationPort: UserApplicationPort
	) {}

	public observeCvTemplates(): Data$<ICvTemplate[]> {
		const api$ = from(this._documentApiPort.fetchCvTemplateDocuments()).pipe(
			switchTap((templates) =>
				this._cvTemplateRepositoryPort.saveCvTemplates(
					this._cvTemplateConverterPort.cvTemplatesAsEntities(templates)
				)
			),
			map((templates) => ({ data: templates, fresh: true })),
			catchError((e) => of({ fresh: true, data: [], error: e })),
			startWith({ fresh: false, data: [] } as RemoteData<CvTemplateOutput[]>)
		);

		const repo$ = this._userApplicationPort
			.observeSessionOrganizationId()
			.pipe(
				switchMap((organizationId: string) =>
					this._cvTemplateRepositoryPort.observeCvTemplates(organizationId)
				)
			);

		return appEntities(api$, repo$);
	}
}
